
export default {
  slug: "guerra-de-parrillas",
  basepath: "content/gallery-guerra-de-parrillas/",
  images: [
    {
      width: 1199, height: 800, file: "18.jpg", name: ""
    },
    {
      width: 1199, height: 800, file: "19.jpg", name: ""
    },
    {
      width: 534, height: 800, file: "20.jpg", name: ""
    },
    {
      width: 1199, height: 800, file: "21.jpg", name: ""
    },
    {
      width: 1199, height: 800, file: "22.jpg", name: ""
    },
    {
      width: 534, height: 800, file: "23.jpg", name: ""
    },
    {
      width: 1199, height: 800, file: "24.jpg", name: ""
    },
    {
      width: 534, height: 800, file: "25.jpg", name: ""
    },
    {
      width: 1199, height: 800, file: "bernardo-borgeat.jpg", name: "Bernardo Borgeat"
    },
    {
      width: 534, height: 800, file: "carlos-arellano.jpg", name: "Carlos Arellano"
    },
    {
      width: 534, height: 800, file: "cristian-jara.jpg", name: "Cristian Jara"
    },
    {
      width: 1197, height: 800, file: "isabel-hrepich---daniel-tarrago.jpg", name: "Isaben Hrepich y Daniel Tarrago"
    },
    {
      width: 534, height: 800, file: "javier-alsina.jpg", name: "Javier Alsina"
    },
    {
      width: 534, height: 800, file: "jose-puentes.jpg", name: "José Puentes"
    },
    {
      width: 1199, height: 800, file: "leslie-mckay---juan-ignacio-bascunan-.jpg", name: "Leslie McKay y Juan Ignacio Bascuñan"
    },
    {
      width: 1199, height: 800, file: "martin-hudson---agustin-walker---matias-moroso---jose-pablo-mnadiola.jpg", name: "Martín Hudson, Agustín Walker, Matías Moroso y José Pablo Mandiola"
    },
    {
      width: 1199, height: 800, file: "patricio-jaramillo---romane-pizarro.jpg", name: "Patricio Jaramillo y Romané Pizarro"
    },
    {
      width: 1199, height: 800, file: "patricio-mora.jpg", name: "Patricio Mora"
    },
    {
      width: 1199, height: 800, file: "pia-saez---nicolas-contreras.jpg", name: "Pía Saez y Nicolás Contreras"
    },
    {
      width: 1199, height: 800, file: "reimundo-strauszer.jpg", name: "Reimundo Strauszer"
    },
    {
      width: 1199, height: 800, file: "sebastian-schnaidt---ludwing-von-plessing.jpg", name: "Sebastián Schnaidt y Ludwing Von Plessing"
    },
    {
      width: 1199, height: 800, file: "sonia-romo---antonia-guzman.jpg", name: "Sonia Romo y Antonia Guzmán"
    },
    {
      width: 1199, height: 800, file: "thomas-brain---martin-aracena.jpg", name: "Thomas Brain y Martín Aracena"
    },
    {
      width: 1199, height: 800, file: "ximena-delajara---javier-leal.jpg", name: "Ximena De La Jara y Javier Leal" },
  ]
}